export const SEO_PAGE_MAKE = 'MAKE';
export const SEO_PAGE_MODEL = 'MODEL';
export const SEO_PAGE_SUBTYPE = 'SUBTYPE';
export const SEO_PAGE_CITY = 'CITY';
export const SEO_PAGE_CITY_MAKE = 'CITY_MAKE';
export const SEO_PAGE_CITY_MODEL = 'CITY_MODEL';
